export const countriesList = { en:
    [{"country": "Afghanistan", "code": "AF"},
    {"country": "Albania", "code": "AL"},
    {"country": "Algeria", "code": "DZ"},
    {"country": "Andorra", "code": "AD"},
    {"country": "Angola", "code": "AO"},
    {"country": "Antigua and Barbuda", "code": "AG"},
    {"country": "Argentina", "code": "AR"},
    {"country": "Armenia", "code": "AM"},
    {"country": "Australia", "code": "AU"},
    {"country": "Austria", "code": "AT"},
    {"country": "Azerbaijan", "code": "AZ"},
    {"country": "Bahamas", "code": "BS"},
    {"country": "Bahrain", "code": "BH"},
    {"country": "Bangladesh", "code": "BD"},
    {"country": "Barbados", "code": "BB"},
    {"country": "Belarus", "code": "BY"},
    {"country": "Belgium", "code": "BE"},
    {"country": "Belize", "code": "BZ"},
    {"country": "Benin", "code": "BJ"},
    {"country": "Bhutan", "code": "BT"},
    {"country": "Bolivia", "code": "BO"},
    {"country": "Bosnia and Herzegovina", "code": "BA"},
    {"country": "Botswana", "code": "BW"},
    {"country": "Brazil", "code": "BR"},
    {"country": "Brunei", "code": "BN"},
    {"country": "Bulgaria", "code": "BG"},
    {"country": "Burkina Faso", "code": "BF"},
    {"country": "Burundi", "code": "BI"},
    {"country": "Cabo Verde", "code": "CV"},
    {"country": "Cambodia", "code": "KH"},
    {"country": "Cameroon", "code": "CM"},
    {"country": "Canada", "code": "CA"},
    {"country": "Central African Republic", "code": "CF"},
    {"country": "Chad", "code": "TD"},
    {"country": "Chile", "code": "CL"},
    {"country": "China", "code": "CN"},
    {"country": "Colombia", "code": "CO"},
    {"country": "Comoros", "code": "KM"},
    {"country": "Congo, Democratic Republic of the", "code": "CD"},
    {"country": "Congo, Republic of the", "code": "CG"},
    {"country": "Costa Rica", "code": "CR"},
    {"country": "Croatia", "code": "HR"},
    {"country": "Cuba", "code": "CU"},
    {"country": "Cyprus", "code": "CY"},
    {"country": "Czech Republic", "code": "CZ"},
    {"country": "Denmark", "code": "DK"},
    {"country": "Djibouti", "code": "DJ"},
    {"country": "Dominica", "code": "DM"},
    {"country": "Dominican Republic", "code": "DO"},
    {"country": "Ecuador", "code": "EC"},
    {"country": "Egypt", "code": "EG"},
    {"country": "El Salvador", "code": "SV"},
    {"country": "Equatorial Guinea", "code": "GQ"},
    {"country": "Eritrea", "code": "ER"},
    {"country": "Estonia", "code": "EE"},
    {"country": "Eswatini", "code": "SZ"},
    {"country": "Ethiopia", "code": "ET"},
    {"country": "Fiji", "code": "FJ"},
    {"country": "Finland", "code": "FI"},
    {"country": "France", "code": "FR"},
    {"country": "Gabon", "code": "GA"},
    {"country": "Gambia", "code": "GM"},
    {"country": "Georgia", "code": "GE"},
    {"country": "Germany", "code": "DE"},
    {"country": "Ghana", "code": "GH"},
    {"country": "Greece", "code": "GR"},
    {"country": "Grenada", "code": "GD"},
    {"country": "Guatemala", "code": "GT"},
    {"country": "Guinea", "code": "GN"},
    {"country": "Guinea-Bissau", "code": "GW"},
    {"country": "Guyana", "code": "GY"},
    {"country": "Haiti", "code": "HT"},
    {"country": "Honduras", "code": "HN"},
    {"country": "Hungary", "code": "HU"},
    {"country": "Iceland", "code": "IS"},
    {"country": "India", "code": "IN"},
    {"country": "Indonesia", "code": "ID"},
    {"country": "Iran", "code": "IR"},
    {"country": "Iraq", "code": "IQ"},
    {"country": "Ireland", "code": "IE"},
    {"country": "Israel", "code": "IL"},
    {"country": "Italy", "code": "IT"},
    {"country": "Jamaica", "code": "JM"},
    {"country": "Japan", "code": "JP"},
    {"country": "Jordan", "code": "JO"},
    {"country": "Kazakhstan", "code": "KZ"},
    {"country": "Kenya", "code": "KE"},
    {"country": "Kiribati", "code": "KI"},
    {"country": "Korea, Democratic People's Republic of", "code": "KP"},
    {"country": "Korea, Republic of", "code": "KR"},
    {"country": "Kosovo", "code": "XK"},
    {"country": "Kuwait", "code": "KW"},
    {"country": "Kyrgyzstan", "code": "KG"},
    {"country": "Laos", "code": "LA"},
    {"country": "Latvia", "code": "LV"},
    {"country": "Lebanon", "code": "LB"},
    {"country": "Lesotho", "code": "LS"},
    {"country": "Liberia", "code": "LR"},
    {"country": "Libya", "code": "LY"},
    {"country": "Liechtenstein", "code": "LI"},
    {"country": "Lithuania", "code": "LT"},
    {"country": "Luxembourg", "code": "LU"},
    {"country": "Madagascar", "code": "MG"},
    {"country": "Malawi", "code": "MW"},
    {"country": "Malaysia", "code": "MY"},
    {"country": "Maldives", "code": "MV"},
    {"country": "Mali", "code": "ML"},
    {"country": "Malta", "code": "MT"},
    {"country": "Marshall Islands", "code": "MH"},
    {"country": "Mauritania", "code": "MR"},
    {"country": "Mauritius", "code": "MU"},
    {"country": "Mexico", "code": "MX"},
    {"country": "Micronesia", "code": "FM"},
    {"country": "Moldova", "code": "MD"},
    {"country": "Monaco", "code": "MC"},
    {"country": "Mongolia", "code": "MN"},
    {"country": "Montenegro", "code": "ME"},
    {"country": "Morocco", "code": "MA"},
    {"country": "Mozambique", "code": "MZ"},
    {"country": "Myanmar", "code": "MM"},
    {"country": "Namibia", "code": "NA"},
    {"country": "Nauru", "code": "NR"},
    {"country": "Nepal", "code": "NP"},
    {"country": "Netherlands", "code": "NL"},
    {"country": "New Zealand", "code": "NZ"},
    {"country": "Nicaragua", "code": "NI"},
    {"country": "Niger", "code": "NE"},
    {"country": "Nigeria", "code": "NG"},
    {"country": "North Macedonia", "code": "MK"},
    {"country": "Norway", "code": "NO"},
    {"country": "Oman", "code": "OM"},
    {"country": "Pakistan", "code": "PK"},
    {"country": "Palau", "code": "PW"},
    {"country": "Palestine, State of", "code": "PS"},
    {"country": "Panama", "code": "PA"},
    {"country": "Papua New Guinea", "code": "PG"},
    {"country": "Paraguay", "code": "PY"},
    {"country": "Peru", "code": "PE"},
    {"country": "Philippines", "code": "PH"},
    {"country": "Poland", "code": "PL"},
    {"country": "Portugal", "code": "PT"},
    {"country": "Qatar", "code": "QA"},
    {"country": "Romania", "code": "RO"},
    {"country": "Russian Federation", "code": "RU"},
    {"country": "Rwanda", "code": "RW"},
    {"country": "Saint Kitts and Nevis", "code": "KN"},
    {"country": "Saint Lucia", "code": "LC"},
    {"country": "Saint Vincent and the Grenadines", "code": "VC"},
    {"country": "Samoa", "code": "WS"},
    {"country": "San Marino", "code": "SM"},
    {"country": "Sao Tome and Principe", "code": "ST"},
    {"country": "Saudi Arabia", "code": "SA"},
    {"country": "Senegal", "code": "SN"},
    {"country": "Serbia", "code": "RS"},
    {"country": "Seychelles", "code": "SC"},
    {"country": "Sierra Leone", "code": "SL"},
    {"country": "Singapore", "code": "SG"},
    {"country": "Slovakia", "code": "SK"},
    {"country": "Slovenia", "code": "SI"},
    {"country": "Solomon Islands", "code": "SB"},
    {"country": "Somalia", "code": "SO"},
    {"country": "South Africa", "code": "ZA"},
    {"country": "South Sudan", "code": "SS"},
    {"country": "Spain", "code": "ES"},
    {"country": "Sri Lanka", "code": "LK"},
    {"country": "Sudan", "code": "SD"},
    {"country": "Suriname", "code": "SR"},
    {"country": "Sweden", "code": "SE"},
    {"country": "Switzerland", "code": "CH"},
    {"country": "Syrian Arab Republic", "code": "SY"},
    {"country": "Tajikistan", "code": "TJ"},
    {"country": "Tanzania, United Republic of", "code": "TZ"},
    {"country": "Thailand", "code": "TH"},
    {"country": "Timor-Leste", "code": "TL"},
    {"country": "Togo", "code": "TG"},
    {"country": "Tonga", "code": "TO"},
    {"country": "Trinidad and Tobago", "code": "TT"},
    {"country": "Tunisia", "code": "TN"},
    {"country": "Turkey", "code": "TR"},
    {"country": "Turkmenistan", "code": "TM"},
    {"country": "Tuvalu", "code": "TV"},
    {"country": "Uganda", "code": "UG"},
    {"country": "Ukraine", "code": "UA"},
    {"country": "United Arab Emirates", "code": "AE"},
    {"country": "United Kingdom of Great Britain and Northern Ireland", "code": "GB"},
    {"country": "United States of America", "code": "US"},
    {"country": "Uruguay", "code": "UY"},
    {"country": "Uzbekistan", "code": "UZ"},
    {"country": "Vanuatu", "code": "VU"},
    {"country": "Venezuela (Bolivarian Republic of)", "code": "VE"},
    {"country": "Viet Nam", "code": "VN"},
    {"country": "Yemen", "code": "YE"},
    {"country": "Zambia", "code": "ZM"},
    {"country": "Zimbabwe", "code": "ZW"}
  ],
  de:[
    {"country": "Afghanistan", "code": "AF"},
    {"country": "Ägypten", "code": "EG"},
    {"country": "Albanien", "code": "AL"},
    {"country": "Algerien", "code": "DZ"},
    {"country": "Andorra", "code": "AD"},
    {"country": "Angola", "code": "AO"},
    {"country": "Antigua und Barbuda", "code": "AG"},
    {"country": "Äquatorialguinea", "code": "GQ"},
    {"country": "Argentinien", "code": "AR"},
    {"country": "Armenien", "code": "AM"},
    {"country": "Aserbaidschan", "code": "AZ"},
    {"country": "Äthiopien", "code": "ET"},
    {"country": "Australien", "code": "AU"},
    {"country": "Bahamas", "code": "BS"},
    {"country": "Bahrain", "code": "BH"},
    {"country": "Bangladesch", "code": "BD"},
    {"country": "Barbados", "code": "BB"},
    {"country": "Belgien", "code": "BE"},
    {"country": "Belize", "code": "BZ"},
    {"country": "Benin", "code": "BJ"},
    {"country": "Bhutan", "code": "BT"},
    {"country": "Bolivien", "code": "BO"},
    {"country": "Bosnien und Herzegowina", "code": "BA"},
    {"country": "Botsuana", "code": "BW"},
    {"country": "Brasilien", "code": "BR"},
    {"country": "Brunei Darussalam", "code": "BN"},
    {"country": "Bulgarien", "code": "BG"},
    {"country": "Burkina Faso", "code": "BF"},
    {"country": "Burundi", "code": "BI"},
    {"country": "Chile", "code": "CL"},
    {"country": "China", "code": "CN"},
    {"country": "Costa Rica", "code": "CR"},
    {"country": "Dänemark", "code": "DK"},
    {"country": "Deutschland", "code": "DE"},
    {"country": "Dominica", "code": "DM"},
    {"country": "Dominikanische Republik", "code": "DO"},
    {"country": "Dschibuti", "code": "DJ"},
    {"country": "Ecuador", "code": "EC"},
    {"country": "El Salvador", "code": "SV"},
    {"country": "Elfenbeinküste", "code": "CI"},
    {"country": "Eritrea", "code": "ER"},
    {"country": "Estland", "code": "EE"},
    {"country": "Fidschi", "code": "FJ"},
    {"country": "Finnland", "code": "FI"},
    {"country": "Frankreich", "code": "FR"},
    {"country": "Gabun", "code": "GA"},
    {"country": "Gambia", "code": "GM"},
    {"country": "Georgien", "code": "GE"},
    {"country": "Ghana", "code": "GH"},
    {"country": "Grenada", "code": "GD"},
    {"country": "Griechenland", "code": "GR"},
    {"country": "Guatemala", "code": "GT"},
    {"country": "Guinea", "code": "GN"},
    {"country": "Guinea-Bissau", "code": "GW"},
    {"country": "Guyana", "code": "GY"},
    {"country": "Haiti", "code": "HT"},
    {"country": "Honduras", "code": "HN"},
    {"country": "Indien", "code": "IN"},
    {"country": "Indonesien", "code": "ID"},
    {"country": "Irak", "code": "IQ"},
    {"country": "Iran", "code": "IR"},
    {"country": "Irland", "code": "IE"},
    {"country": "Island", "code": "IS"},
    {"country": "Israel", "code": "IL"},
    {"country": "Italien", "code": "IT"},
    {"country": "Jamaika", "code": "JM"},
    {"country": "Japan", "code": "JP"},
    {"country": "Jemen", "code": "YE"},
    {"country": "Jordanien", "code": "JO"},
    {"country": "Kambodscha", "code": "KH"},
    {"country": "Kamerun", "code": "CM"},
    {"country": "Kanada", "code": "CA"},
    {"country": "Kap Verde", "code": "CV"},
    {"country": "Kasachstan", "code": "KZ"},
    {"country": "Katar", "code": "QA"},
    {"country": "Kenia", "code": "KE"},
    {"country": "Kirgisistan", "code": "KG"},
    {"country": "Kiribati", "code": "KI"},
    {"country": "Kolumbien", "code": "CO"},
    {"country": "Komoren", "code": "KM"},
    {"country": "Kongo", "code": "CG"},
    {"country": "Kosovo", "code": "XK"},
    {"country": "Kroatien", "code": "HR"},
    {"country": "Kuba", "code": "CU"},
    {"country": "Kuwait", "code": "KW"},
    {"country": "Laos", "code": "LA"},
    {"country": "Lesotho", "code": "LS"},
    {"country": "Lettland", "code": "LV"},
    {"country": "Libanon", "code": "LB"},
    {"country": "Liberia", "code": "LR"},
    {"country": "Libyen", "code": "LY"},
    {"country": "Liechtenstein", "code": "LI"},
    {"country": "Litauen", "code": "LT"},
    {"country": "Luxemburg", "code": "LU"},
    {"country": "Madagaskar", "code": "MG"},
    {"country": "Malawi", "code": "MW"},
    {"country": "Malaysia", "code": "MY"},
    {"country": "Malediven", "code": "MV"},
    {"country": "Mali", "code": "ML"},
    {"country": "Malta", "code": "MT"},
    {"country": "Marokko", "code": "MA"},
    {"country": "Marshallinseln", "code": "MH"},
    {"country": "Mauretanien", "code": "MR"},
    {"country": "Mauritius", "code": "MU"},
    {"country": "Mazedonien", "code": "MK"},
    {"country": "Mexiko", "code": "MX"},
    {"country": "Mikronesien", "code": "FM"},
    {"country": "Moldawien", "code": "MD"},
    {"country": "Monaco", "code": "MC"},
    {"country": "Mongolei", "code": "MN"},
    {"country": "Montenegro", "code": "ME"},
    {"country": "Mosambik", "code": "MZ"},
    {"country": "Myanmar", "code": "MM"},
    {"country": "Namibia", "code": "NA"},
    {"country": "Nauru", "code": "NR"},
    {"country": "Nepal", "code": "NP"},
    {"country": "Neuseeland", "code": "NZ"},
    {"country": "Nicaragua", "code": "NI"},
    {"country": "Niederlande", "code": "NL"},
    {"country": "Niger", "code": "NE"},
    {"country": "Nigeria", "code": "NG"},
    {"country": "Nordkorea", "code": "KP"},
    {"country": "Norwegen", "code": "NO"},
    {"country": "Oman", "code": "OM"},
    {"country": "Österreich", "code": "AT"},
    {"country": "Pakistan", "code": "PK"},
    {"country": "Palau", "code": "PW"},
    {"country": "Panama", "code": "PA"},
    {"country": "Papua-Neuguinea", "code": "PG"},
    {"country": "Paraguay", "code": "PY"},
    {"country": "Peru", "code": "PE"},
    {"country": "Philippinen", "code": "PH"},
    {"country": "Polen", "code": "PL"},
    {"country": "Portugal", "code": "PT"},
     {"country": "Ruanda", "code": "RW"},
    {"country": "Rumänien", "code": "RO"},
    {"country": "Russland", "code": "RU"},
    {"country": "Salomonen", "code": "SB"},
    {"country": "Sambia", "code": "ZM"},
    {"country": "Samoa", "code": "WS"},
    {"country": "San Marino", "code": "SM"},
    {"country": "São Tomé und Príncipe", "code": "ST"},
    {"country": "Saudi-Arabien", "code": "SA"},
    {"country": "Schweden", "code": "SE"},
    {"country": "Schweiz", "code": "CH"},
    {"country": "Senegal", "code": "SN"},
    {"country": "Serbien", "code": "RS"},
    {"country": "Seychellen", "code": "SC"},
    {"country": "Sierra Leone", "code": "SL"},
    {"country": "Simbabwe", "code": "ZW"},
    {"country": "Singapur", "code": "SG"},
    {"country": "Slowakei", "code": "SK"},
    {"country": "Slowenien", "code": "SI"},
    {"country": "Somalia", "code": "SO"},
    {"country": "Spanien", "code": "ES"},
    {"country": "Sri Lanka", "code": "LK"},
    {"country": "St. Kitts und Nevis", "code": "KN"},
    {"country": "St. Lucia", "code": "LC"},
    {"country": "St. Vincent und die Grenadinen", "code": "VC"},
    {"country": "Südafrika", "code": "ZA"},
    {"country": "Sudan", "code": "SD"},
    {"country": "Südkorea", "code": "KR"},
    {"country": "Südsudan", "code": "SS"},
    {"country": "Suriname", "code": "SR"},
    {"country": "Swasiland", "code": "SZ"},
    {"country": "Syrien", "code": "SY"},
    {"country": "Tadschikistan", "code": "TJ"},
    {"country": "Taiwan", "code": "TW"},
    {"country": "Tansania", "code": "TZ"},
    {"country": "Thailand", "code": "TH"},
    {"country": "Togo", "code": "TG"},
    {"country": "Tonga", "code": "TO"},
    {"country": "Trinidad und Tobago", "code": "TT"},
    {"country": "Tschad", "code": "TD"},
    {"country": "Tschechien", "code": "CZ"},
    {"country": "Türkei", "code": "TR"},
    {"country": "Turkmenistan", "code": "TM"},
    {"country": "Tuvalu", "code": "TV"},
    {"country": "Uganda", "code": "UG"},
    {"country": "Ukraine", "code": "UA"},
    {"country": "Ungarn", "code": "HU"},
    {"country": "Uruguay", "code": "UY"},
    {"country": "Usbekistan", "code": "UZ"},
    {"country": "Vanuatu", "code": "VU"},
    {"country": "Vatikanstadt", "code": "VA"},
    {"country": "Venezuela", "code": "VE"},
    {"country": "Vereinigte Arabische Emirate", "code": "AE"},
    {"country": "Vereinigtes Königreich", "code": "GB"},
    {"country": "Vereinigte Staaten von Amerika", "code": "US"},
    {"country": "Vietnam", "code": "VN"},
    {"country": "Zentralafrikanische Republik", "code": "CF"},
    {"country": "Zypern", "code": "CY"}
    ]
    
  };
  